<template>
  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-12">
        <button class="btn btn-sm tnkc-secondary mb-2 mx-1 text-white float-right hide-on-print" @click="goBack">
          <font-awesome-icon icon="undo"/>
          Go Back
        </button>
        <button class="btn btn-sm tnkc-primary mb-2 mx-1 float-right hide-on-print" @click="printForm">
          <font-awesome-icon icon="print"/>
          Print Form
        </button>
      </div>
    </div>
    <div class="container">
      <div class="text-center line-height-0 font-weight-bold text-small">
        <img :src="tnkcBanner" alt="" width="250px">
        <p class="lead font-weight-bold mt-1">VISTA DEL MAR REALTY</p>
        <p>Address: <span class="tnkc-success-text">944 PARIS ST. LEON GUINTO, MANILA</span></p>
        <p>Trunkline Number: <span class="tnkc-success-text">516-6220 - 516-6221 - 516-6223</span></p>
        <p>Direct Line: <span class="tnkc-success-text">516-6277</span></p>
        <br />
        <p>Control Number: <span class="tnkc-danger-text">{{reservation_bookings.control_number}}</span></p>
      </div>
      <table class="table table-sm table-bordered text-center my-5">
        <thead>
        <tr>
          <th scope="col">RANK / CREW</th>
          <th scope="col">ROOM</th>
          <th scope="col">INTENDED VESSEL</th>
          <th scope="col">CHECK IN</th>
          <th scope="col">CHECK OUT</th>
          <th scope="col">DAY(S)</th>
          <th scope="col">ESTIMATED COST</th>
        </tr>
        </thead>
        <tbody>
<!--        {{reservation_bookings}}-->
        <tr v-for="reservation_booking in reservation_bookings.booking_details">
          <td>{{ reservation_bookings.crew }}</td>
          <td>{{ reservation_booking.room_name }}</td>
          <td>{{ reservation_bookings.vessel }}</td>
          <td>{{ reservation_booking.check_in | moment('D MMM YYYY')}}</td>
          <td>{{ reservation_booking.check_out | moment('D MMM YYYY')}}</td>
          <td>{{ reservation_booking.days_stayed }}</td>
          <td>{{ reservation_booking.total_rate }}</td>
        </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-md-auto">
          <span class="font-weight-bold">PURPOSE:</span>
        </div>
        <div class="col-md-auto text-dark text-left">
          <div class="form-check" v-for="purpose in purposes">
            <input class="form-check-input" type="checkbox"
                   v-model="reservation_bookings.purposes"
                   :value="purpose.id" :id="purpose.id" disabled>
            <label class="form-check-label text-uppercase" :for="purpose.id">
              {{ purpose.description }}
            </label>
          </div>
        </div>
      </div>
      <div class="row font-weight-bold mt-5 d-flex justify-content-center text-uppercase">
        <div class="col-sm-12 text-center mb-5">
          <p>Prepared by: </p>
            <p class="my-2">
              {{ reservation_bookings.endorsed_by }}
            </p>
          <span class="border-top px-5 border-dark">Doc Staff</span>
        </div>
        <div class="col-sm-auto text-center mx-5" v-for="reservation_booking in reservation_bookings.booking_details">
          <p>Booked by: </p>
          <p class="my-2">
            {{ reservation_booking.hotel_code }}
            {{ reservation_booking.room_code }} :
            {{ reservation_booking.booked_by }}
          </p>
          <span class="border-top px-5 border-dark">TNKC Admin</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import TnkcBanner from '../../assets/tnkc-banner.png';
    import {appMixins} from '@/mixins/app.mixins';
    import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'CrewRsrvForm',
    props: ['id'],
    mixins: [appMixins],
    data(){
      return{
        tnkcBanner : TnkcBanner,
      }
    },
    methods: {
      ...mapActions(['getPurposeList','getLatestReservationBookings']),

      printForm(){
        window.print();
      }
    },
    computed: {
      ...mapGetters(['purposes','reservation_bookings'])
    },
    created() {
      this.getPurposeList();
      this.getLatestReservationBookings(this.id);
    },
  };
</script>

<style scoped>
.line-height-0 * {
  line-height: 0.2;
}

</style>